import React, { useEffect, useRef, useState } from 'react';
import { readQueryParam } from '../../../utils/helper';
import { useSelector } from 'react-redux';
import { odPushTTQEvent } from '../../../utils/tiktokPixel';
import { filterHelper } from './FilterPanel/FilterPanel.helper';
import './ProductFilterPanel.scss';
import FilterPanel from './FilterPanel/FilterPanel';
import ActiveFilters from './FilterPanel/ActiveFilters/ActiveFilters';
import ProductGridSkeletons from '../../../desktop/components/CategoryListing/ProductSkeletons/ProductGridSkeletons';
import useMediaQuery from '../../../utils/useMediaQuery';
import BottomFilterBar from './FilterPanel/BottomFilterBar/BottomFilterBar';

const FilterDtm = {
  updateFilterDtm: (filterName, filterType) => {
    let parentKeyToUpdateDtm = filterName;
    if (parentKeyToUpdateDtm?.indexOf('_id') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace(/_/g, '').replace('id', '');
    } else if (parentKeyToUpdateDtm?.indexOf('lenskart') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace('lenskart_', '');
    } else if (parentKeyToUpdateDtm?.indexOf('price') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.concat('range');
    }
    if (filterType) window.dtm.filterType = 'clear all';

    window.dtm[parentKeyToUpdateDtm] = 'clear';
  },
  updateCategoryDtm: (categoryData, dtmArg) => {
    let subC = '';
    const { userInfo, login, sort, filter } = dtmArg;
    const bCrumbArr =
      categoryData.breadcrumb && categoryData.breadcrumb.length ? categoryData.breadcrumb : [];
    const categoryType = categoryData.categoryType ? categoryData.categoryType.toLowerCase() : '';
    bCrumbArr.forEach(data => {
      if (data) {
        subC += `${data.label}-`;
      }
    });
    if (window.dtm !== undefined) {
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.allPage('listing page');
        window.dtm.LenskartRewamp.Listing.load.listing(
          categoryType,
          subC ? subC.slice(0, -1) : categoryType,
          filter,
          sort.toLowerCase(),
          login,
          login ? userInfo.result.id : '',
          dtmArg.obj
        );
      }
    }
  },
};

const ProductFilterPanel = props => {
  const {
    categoryID,
    redisCommonData,
    isCachedData,
    powerUrls,
    location,
    children,
    addingGaDataInFilterArray,
    filterArray,
    FilterDataObj,
    categoryActions,
    showSortDropdown,
    toggleSortDropdown,
    isCategoryTab,
  } = props;

  const userInfo = useSelector(state => state.common.userInfo);
  const filterData = useSelector(state => state.category.filterData);
  const categoryData = useSelector(state => state.category?.categoryData);
  const sortWrapperRefTop = useRef(null);
  const sortWrapperRefBottom = useRef(null);
  const [appliedTypeCount, setAppliedTypeCount] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [mobilePendingSelections, setMobilePendingSelections] = useState({});
  const isMobileSize = useMediaQuery('(max-width: 768px)');
  const pageParam = Number(readQueryParam('page', location.search, true));
  const searchTextParam = readQueryParam('q', location.search, true);
  const [showFilterMobile, setShowFilterMobile] = useState(false);
  const isSearch = location.pathname.includes('search');
  const [overrideProductList, setOverrideProductList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const numberOfProductsNotShownDueToPageParam =
    !isCachedData && pageParam ? pageParam * redisCommonData.CATEGORY_PAGE_SIZE_COUNT : 0;

  useEffect(() => {
    if (searchTextParam) {
      odPushTTQEvent('Search', { userInfo });
    }
  }, []);

  const loadCatData = data => {
    let mystring = '';
    const incLimit = Object.keys(data).length - 1;
    Object.keys(data).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key;
      data[key].forEach((val, index) => {
        if (index === data[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (parentIndex === incLimit) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    let loc = '';
    if (location.hash.includes('dir')) {
      if (location.hash.split('dir')[0].length > 0 && location.hash.split('dir')[0].length !== 1) {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir') - 1,
          location.hash.lastIndexOf('true') + 4
        );
      } else {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir'),
          location.hash.lastIndexOf('true') + 4
        );
      }
    }

    let searchQuery = '';
    if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
      const queryParam = readQueryParam('q', location.search, true);
      searchQuery = `?q=${queryParam}`;
    }

    history.replaceState(
      `${location.pathname}${window.location.hash}`,
      null,
      location.pathname + `${searchQuery}${window.location.hash}`
    );

    categoryActions.loadCatAndFilterData(categoryID, mystring + loc, 0);
  };

  const handleFilter = (name, array, TempData, apiTempData = {}) => {
    filterHelper(name, FilterDataObj, TempData, apiTempData, array, categoryActions, loadCatData);
  };

  const modifySelectedFilterList = (childname, childid, currentFilterData) => {
    const childData = FilterDataObj[currentFilterData.id] || [];
    const index = childData.findIndex(
      item => JSON.stringify(item) === JSON.stringify({ childid, childname })
    );

    if (index > -1) {
      childData.splice(index, 1);
    } else {
      childData.push({ childid, childname });
    }

    const filter = {
      [currentFilterData?.id]: childname,
    };
    const allFilter = [filter];

    const isContainFilterData = false;

    if (allFilter.length > 0 && !isContainFilterData) {
      const totalFilter = allFilter.length;
      const appliedFilterString = Object.assign({}, ...allFilter);

      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.filter.appliedFilter(appliedFilterString, totalFilter);
    }

    addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname);

    // Update DTM value when filter removed
    if (childData.length === 0) FilterDtm.updateFilterDtm(currentFilterData.id);

    handleFilter(currentFilterData.id, childData);
  };

  const shouldRenderSkeleton =
    isLoading ||
    (!categoryData.result && categoryData.code !== 17 && filterData && !filterData.error);

  useEffect(() => {
    const handleOutside = e => {
      if (
        showSortDropdown &&
        !sortWrapperRefTop.current?.contains(e.target) &&
        !sortWrapperRefBottom.current?.contains(e.target)
      ) {
        toggleSortDropdown();
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [showSortDropdown]);

  useEffect(() => {
    if (isSearch) return;
    
    const handleScroll = () => {
      const header = document.querySelector('.odHeader--fixed');
      const stickyFilter = document.querySelector('.product-category-filter-panel');
      if (!header || !stickyFilter) return;

      const stickyFilterTop = stickyFilter.getBoundingClientRect().top;

      if (window.scrollY > 0) {
        if (stickyFilterTop > 0) {
          header.classList.add('header-visible');
          header.classList.remove('header-hidden');
        } else {
          header.classList.remove('header-visible');
          header.classList.add('header-hidden');
        }
      } else {
        header.classList.remove('header-visible');
        header.classList.remove('header-hidden');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const currentHash = window.location.hash;

    if (path.includes('newarrival') && !currentHash) {
      const newHash = '#dir=desc&sort=created&gan_data=true';
      history.pushState('', '', `${path}${newHash}`);
      categoryActions.loadCatAndFilterData(categoryID, newHash, 0);
    }
  }, []);

  const toggleFilterMobile = () => {
    setShowFilterMobile(prev => !prev);
  };

  const noResultsByProductCount = categoryData?.result?.num_of_products === 0;
  const noResultsByCode = categoryData?.result?.code === 17;
  const noResultsByError = !categoryData?.result && filterData && filterData.error;
  const shouldShowNoResults = noResultsByProductCount || noResultsByCode || noResultsByError;
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const sortParam = hashParams.get('sort') || '';

  let sortPanelOverlayClass = '';

  if (isMobileSize && showSortDropdown) {
    sortPanelOverlayClass = 'sort-panel-overlay active';
  } else if (isMobileSize) {
    sortPanelOverlayClass = 'sort-panel-overlay';
  }

  let productContainerClass = '';

  if (shouldRenderSkeleton) {
    productContainerClass = isSearch ? 'product-grid--search' : 'product-grid';
  } else {
    productContainerClass = 'product-flex';
    if (isSearch) {
      productContainerClass += ' product-flex--search';
    }
  }

  return (
    <div className="product-category-filter-panel">
      <div
        className={`w-full product-category-active-filter ${
          isSearch ? 'product-category-active-filter--search' : ''
        }`}
      >
        <ActiveFilters
          {...props}
          categoryId={categoryID}
          initialIndex={numberOfProductsNotShownDueToPageParam}
          isSearch={isSearch}
          location={location}
          modifySelectedFilterList={modifySelectedFilterList}
          powerUrls={{ powerUrls }}
          showSortDropdown={showSortDropdown}
          sortWrapperRef={sortWrapperRefTop}
          toggleSortDropdown={toggleSortDropdown}
          totalProducts={categoryData?.result?.num_of_products}
        />
        {!isSearch && (
          <div className={sortPanelOverlayClass}>
            {showSortDropdown &&
              React.cloneElement(children.sortFilter, {
                showSortDropdown,
                animate: showSortDropdown,
              })}
          </div>
        )}
      </div>
      <div className="w-full product-category-container">
        {!isSearch && (
          <div className={`product-category-container__filter ${showFilterMobile ? 'active' : ''}`}>
            <FilterPanel
              setAppliedTypeCount={setAppliedTypeCount}
              setSelectedOptions={setSelectedOptions}
              filterArray={filterArray}
              setShowFilterMobile={setShowFilterMobile}
              addingGaDataInFilterArray={addingGaDataInFilterArray}
              categoryId={categoryID}
              mobilePendingSelections={mobilePendingSelections}
              selectedOptions={selectedOptions}
              showFilterMobile={showFilterMobile}
              setMobilePendingSelections={setMobilePendingSelections}
              isCategoryTab={isCategoryTab}
              isMobileSize={isMobileSize}
            />
          </div>
        )}
        <div
          className={`product-category-container__list ${
            isSearch ? 'product-category-container__list--search' : ''
          }`}
        >
          <div className={productContainerClass}>
            <React.Fragment>
              {!shouldRenderSkeleton
                ? React.cloneElement(children.productList, {
                    selectedOptions,
                    setSelectedOptions,
                    mobilePendingSelections,
                    setMobilePendingSelections,
                    overrideProductList,
                    isSearch,
                  })
                : !isSearch && (
                    <>
                      <ProductGridSkeletons
                        styleObj={
                          filterData?.result?.filters?.length === 0
                            ? 'category-loader full-width'
                            : 'category-loader'
                        }
                      />
                    </>
                  )}
            </React.Fragment>
          </div>
          {shouldShowNoResults && (
            <div className="no-result-container">
              <p className="no-result-found margin-b20 fs20 padding-t70 text-capitalize">
                No results found
              </p>
            </div>
          )}
        </div>
      </div>
      {isMobileSize && !isSearch && (
        <BottomFilterBar
          appliedTypeCount={appliedTypeCount}
          order={sortParam}
          sortWrapperRef={sortWrapperRefBottom}
          toggleFilterMobile={toggleFilterMobile}
          toggleSortDropdown={toggleSortDropdown}
        />
      )}
    </div>
  );
};

export default ProductFilterPanel;
